import { SERVICE_EVENTS, STATUS_IN_PROGRESS } from '@/consts/services'
import { getAllEvents } from '@/utils/services'
import { TYPE_AGENT_LEAVE_PREMISES, TYPE_AGENT_RETURN } from '@/consts/events'
import { parseIso } from '@/utils/data/date'

export default {
  /**
   * Le site du service actif
   * @param state
   * @param getters
   * @returns {{}}
   */
  site: (state, getters) => {
    return _.get(getters, ['serviceActif', 'site'])
  },

  /**
   * Les events du service actif par ordre chrono inverse
   * @param state
   * @returns {*[]}
   */
  events: (state) => {
    return [..._.get(state, ['active', SERVICE_EVENTS], [])].reverse()
  },

  /**
   * Détermine si le service actif est un circuit
   * @param state
   * @returns {*}
   */
  isCircuit: (state) => {
    return _.get(state, ['active', 'isCircuit'], false)
  },

  /**
   * Retourne le service actif
   * Dans le cas d'un circuit, le service qui est en status IN_PROGRESS
   * @param state
   * @param getters
   */
  serviceActif: (state, getters) => {
    const { active } = state
    if (getters.isCircuit) {
      return (active.services || []).find((s) => s.status === STATUS_IN_PROGRESS)
    }
    return active
  },

  /**
   * Etape suivante du circuit
   * @param state
   */
  nextCircuitService: (state) => {
    return _.get(state, ['active', 'services'], []).find((s) => s.status === 100)
  },

  /**
   * Les events du service actif par ordre chrono inverse
   * @param state
   * @param getters
   * @returns {*[]}
   */
  serviceEvents: (state, getters) => {
    return [..._.get(getters, ['serviceActif', SERVICE_EVENTS], [])].reverse()
  },

  /**
   * Liste complète des events y compris pour les circuits
   * @param state
   * @returns {*[]}
   */
  allServiceEvents: ({ active }) => {
    if (!active) return []
    return getAllEvents(active)
  },

  /**
   * Détermine si un signalement de sortie de périmète à déjà été fait et qu'aucun retour n'a été acté
   * @param state
   * @param getters
   */
  inSitePerimeter: (state, getters) => {
    let hasReturnEvent = false
    return getters.serviceEvents.every(({ type: { typeKey } }) => {
      switch (typeKey) {
        case TYPE_AGENT_LEAVE_PREMISES.typeKey:
          return false
        case TYPE_AGENT_RETURN.typeKey:
          hasReturnEvent = true
          break
      }
      return true
    }) || hasReturnEvent
  },

  /**
   * Cherche un event par référence
   * @param state
   * @param getters
   * @returns {function(*): *}
   */
  getEventByReference: (state, getters) => (reference) => getters.allServiceEvents.find((e) => e.reference === reference),

  /**
   * Heure en seconde de début du service
   * @param state
   * @returns {number}
   */
  startAtTime: (state) => {
    const startAt = _.get(state, ['active', 'startAt'])
    return startAt
      ? parseIso(startAt).getTime()
      : null
  },

  /**
   * Heure en seconde de fin du service
   * @param state
   * @returns {number}
   */
  endAtTime: (state) => {
    const endAtTime = _.get(state, ['active', 'endAt'])
    return endAtTime
      ? parseIso(endAtTime).getTime()
      : null
  }
}
